<app-form-input
[parentForm]="parentForm"
[disabled]="disabled"

[value]="lot.numLot"

[label]="step4.getnumlot"
[type]="'text'" [rule]="'minSize_1|maxSize_255|required'"
[errorMessage]="{'required' : 'ctr_150'}"
[name]="getUid()+'_SepAtt_numLot'">
</app-form-input>

<app-form-input
[parentForm]="parentForm"
[disabled]="disabled"

[value]="lot.description"

[label]="step4.getdescription"
[type]="'text'"
[rule]="'required|minSize_5'"
[errorMessage]="{'required' : 'ctr_151'}"
[name]="getUid()+'_SepAtt_description'">
</app-form-input>

<app-form-input
[parentForm]="parentForm"
[disabled]="disabled"

[value]="lot.quantite"

[label]="step4.getquantite"
[type]="'text'" [rule]="'minSize_1|maxSize_255'"
[name]="getUid()+'_SepAtt_quantite'">
</app-form-input>


<app-form-input
[parentForm]="parentForm"
[disabled]="disabled"

[value]="lot.dateExecution"

[label]="step4.getdateexecution"
[type]="'date'" [rule]="'pattern_7'"
[errorMessage]="{'pattern' : 'ctr_pattern7'}"
[name]="getUid()+'_SepAtt_dateExecution'">
</app-form-input>


<app-form-input
[parentForm]="parentForm"
[disabled]="disabled"

[value]="lot.dateLivraison"

[label]="step4.getdatelivraison"
[type]="'date'" [rule]="'pattern_7'"
[errorMessage]="{'pattern' : 'ctr_pattern7'}"
[name]="getUid()+'_SepAtt_dateLivraison'">
</app-form-input>







